import PropTypes from 'prop-types';

import aureaCLogo from '../../../assets/logos/AUREA_clogo.svg';
import aureaLogo from '../../../assets/logos/AUREA_logo.svg';
import aureaNLogo from '../../../assets/logos/AUREA_nlogo.svg';
import aureaSLogo from '../../../assets/logos/AUREA_slogo.svg';
import bfacmLogo from '../../../assets/logos/BFACM_logo.svg';
import bfacmSLogo from '../../../assets/logos/BFACM_slogo.svg';
import bpcLogo from '../../../assets/logos/BPC_logo.svg';
import bpcSLogo from '../../../assets/logos/BPC_slogo.svg';
import bancoValorLogo from '../../../assets/logos/BVALOR_logo.svg';
import bancoValorSLogo from '../../../assets/logos/BVALOR_slogo.svg';
import finantechLogo from '../../../assets/logos/FINANTECH_logo.svg';
import finantechNLogo from '../../../assets/logos/FINANTECH_nlogo.svg';
import finantechSLogo from '../../../assets/logos/FINANTECH_slogo.svg';
import finantechSNLogo from '../../../assets/logos/FINANTECH_snlogo.svg';
import hemeraCLogo from '../../../assets/logos/HEMERA_clogo.svg';
import hemeraLogo from '../../../assets/logos/HEMERA_logo.svg';
import hemeraNLogo from '../../../assets/logos/HEMERA_nlogo.svg';
import hemeraSLogo from '../../../assets/logos/HEMERA_slogo.svg';
import standardCLogo from '../../../assets/logos/STANDARD_clogo.svg';
import standardLogo from '../../../assets/logos/STANDARD_logo.svg';
import standardSLogo from '../../../assets/logos/STANDARD_slogo.svg';
import { ICONS_ENUM } from './IconEnum';

export const Icon = ({ iconI, ...rest }) => {
  if (iconI === 'AUREA_LOGO') {
    return <img src={aureaLogo} alt="Aurea Logo" {...rest} />;
  }
  if (iconI === 'AUREA_SLOGO') {
    return <img src={aureaSLogo} alt="Aurea Logo" {...rest} />;
  }
  if (iconI === 'AUREA_NLOGO') {
    return <img src={aureaNLogo} alt="Aurea Logo" {...rest} />;
  }
  if (iconI === 'AUREA_CLOGO') {
    return <img src={aureaCLogo} alt="Aurea Logo" {...rest} />;
  }
  if (iconI === 'STANDARD_LOGO') {
    return <img src={standardLogo} alt="Standard Logo" {...rest} />;
  }
  if (iconI === 'STANDARD_SLOGO') {
    return <img src={standardSLogo} alt="Standard Logo" {...rest} />;
  }
  if (iconI === 'STANDARD_NLOGO') {
    return <img src={standardLogo} alt="Standard Logo" {...rest} />;
  }
  if (iconI === 'STANDARD_CLOGO') {
    return <img src={standardCLogo} alt="Standard Logo" {...rest} />;
  }
  if (iconI === 'BFACM_LOGO') {
    return <img src={bfacmLogo} alt="BFACM Logo" {...rest} />;
  }
  if (iconI === 'BFACM_SLOGO') {
    return <img src={bfacmSLogo} alt="BFACM Logo" {...rest} />;
  }
  if (iconI === 'HEMERA_LOGO') {
    return <img src={hemeraLogo} alt="HEMERA Logo" {...rest} />;
  }
  if (iconI === 'HEMERA_SLOGO') {
    return <img src={hemeraSLogo} alt="HEMERA Logo" {...rest} />;
  }
  if (iconI === 'HEMERA_NLOGO') {
    return <img src={hemeraNLogo} alt="HEMERA Logo" {...rest} />;
  }
  if (iconI === 'HEMERA_CLOGO') {
    return <img src={hemeraCLogo} alt="HEMERA Logo" {...rest} />;
  }
  if (iconI === 'BPC_LOGO') {
    return <img src={bpcLogo} alt="BPC Logo" {...rest} />;
  }
  if (iconI === 'BPC_SLOGO') {
    return <img src={bpcSLogo} alt="BPC Logo" {...rest} />;
  }
  if (iconI === 'BPC_NLOGO') {
    return <img src={bpcLogo} alt="BPC Logo" {...rest} />;
  }
  if (iconI === 'BVALOR_LOGO') {
    return <img src={bancoValorLogo} alt="BVALOR Logo" {...rest} />;
  }
  if (iconI === 'BVALOR_SLOGO') {
    return <img src={bancoValorSLogo} alt="BVALOR Logo" {...rest} />;
  }
  if (iconI === 'BVALOR_NLOGO') {
    return <img src={bancoValorLogo} alt="BVALOR Logo" {...rest} />;
  }
  if (iconI === 'FINANTECH_LOGO') {
    return <img src={finantechLogo} alt="Finantech Logo" {...rest} />;
  }
  if (iconI === 'FINANTECH_SLOGO') {
    return <img src={finantechSLogo} alt="Finantech Logo" {...rest} />;
  }
  if (iconI === 'FINANTECH_NLOGO' || iconI === 'FINANTECH_CLOGO') {
    return <img src={finantechNLogo} alt="Finantech Logo" {...rest} />;
  }
  switch (iconI) {
    case ICONS_ENUM.logo:
      return <img src={finantechLogo} alt="" {...rest} />;
    case ICONS_ENUM.logoNegative:
      return <img src={finantechNLogo} alt="" {...rest} />;
    case ICONS_ENUM.slogo:
      return <img src={finantechSLogo} alt="" {...rest} />;
    case ICONS_ENUM.slogoNegative:
      return <img src={finantechSNLogo} alt="" {...rest} />;
    default:
      return (
        <svg {...rest}>
          <use href="symbol-defs.svg#AD_TL" />
        </svg>
      );
  }
};

Icon.propTypes = {
  iconI: PropTypes.any.isRequired,
};
